<template>
<div class="class">
  <!-- Vertical Card Div -->
  <div class="v_card" activity_class="">
    <div class="v_card_head">
      <div style="text-transform: uppercase;">{{category.name}}</div>
      <div class="v_card_datetime">{{dateRange}}</div>
    </div>
    <div class="v_card_content">
      <div v-if="category.activities.length == 0" style="text-align: center;">暫無任務</div>
      <ActivityCell v-for="activity in category.activities" :key="activity.id" :activity="activity"/>
    </div>
  </div>
</div>
</template>
<style scoped>
  .btn-mark{
    color: white;
    font-size: smaller;
    font-weight: bolder;
    background-color: rgb(129,186,133);
    padding: 10px;
    border-radius: 6px;
    user-select: none;
  }
  .class {
      padding-top: 25px;
      padding-bottom: 25px;
      margin: auto;
      max-width: 80%;
      /*max-width: 500px;*/
    }
  .v_card{
    -moz-box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    box-shadow: var(--box-shadow);

    background-color: white;
    padding: 15px;
    border-radius: 11px;
    font-size: 15pt;
    font-weight: bold;
    color: var(--theme-light-color);
  }
  .no_act{
    color:rgb(158, 160, 163);
  }
  .v_card_head{
    height: 50px;
  }
  @media(min-width: 992px){
    .v_card {
        height: 100%;
    }
    .class {
        padding-right: 25px;
        padding-left: 25px;
        min-width: 700px;
        height: 100%;
      }
    .v_card_datetime {
        font-weight:lighter;
        font-size:13pt;
    }

    .v_card_content {
        overflow: scroll;
        height: calc( 100% - 50px );
    }

    .v_card_row {
        padding:15px 5px 15px 0;
    }

    .v_card_row_title {
        font-weight:bolder;
        font-size:14pt;
        margin-top:10px;
        color:rgb(113, 116, 121);
    }

    .v_card_row_content {
        font-weight:lighter;
        color:rgb(113, 116, 121);
        font-size:12pt;
    }

    .complete_rate_num {
        color:rgb(234,125,113);
    }

    .complete_rate {
        font-size:14pt;
        font-weight:lighter;
        color:rgb(113, 116, 121);
    }

    .donut-size {
        font-size: 3.2em!important;
    }

    .line_br {
        height:2px;
        border-bottom:0.5px solid;
    }

    .pop_edit {
        min-width: 150px;
        color: #A5A6A8;
        border-radius: 0;
    }
    .act_status_mark {
        float: right;
        font-weight: bolder;
        color: red;
        font-size: 16pt;
    }
    .no_act{
        margin-top:55%;
        margin-left:30%;
        color:rgb(158, 160, 163);
        font-weight:normal;
    }
  }
  .activity{
    border-bottom: 1px solid var(--theme-color);
    margin: 15px 0;
  }
  .activity[draggable=true]{
    cursor: move;
  }
  .edit_list > ul {
      list-style: none;
      padding-inline-start: 0px;
      margin: 0;
  }

  .edit_list > ul > li {
      padding-left: 18px;
      color:rgb(181, 182, 185);
  }
  .edit_list > ul > li > div {
      cursor:pointer;
  }
  .edit_list > ul > li:hover {
      background-color:rgb(125, 192, 129);
      color:white;
  }
@media screen and (max-width: 790px) {
  .class {
    margin: auto;
    width: calc( 100vw - 2rem );
  }
}
</style>
<script>
import ActivityCell from '@/components/Weeks/ActivityCell'
export default {
  components: {
    ActivityCell
  },
  props: {
    category: Object,
    showName: Boolean
  },
  data () {
    return {
      courseId: this.$parent.courseId,
      weekId: this.$parent.id,
      role: this.$parent.role,
      dateRange: this.category.end_datetime !== undefined && this.category.start_datetime !== undefined ? `${this.category.start_datetime} - ${this.category.end_datetime}` : ''
    }
  },
  computed: {
    isTeacher: function () {
      return this.role === 'teacher'
    }
  }
}
</script>
